export enum UserCourseStatus {
  Active = "active",
  Upcoming = "upcoming",
  Past = "past",
}

export enum CourseStatus {
  Active = "active",
  Inactive = "inactive",
  Template = "template",
}

export enum ProgressStatus {
  NotStarted = "NotStarted",
  InProgress = "InProgress",
  Completed = "Completed",
  Modified = "Modified",
  PendingGrade = "PendingGrade",
}

export enum CourseItemType {
  Unit = "Unit",
  Topic = "Topic",
  Day = "Day",
}

export enum DayItemType {
  Lesson = "Lesson",
  Assessment = "Assessment",
}
